export const BRIDGE_BIO_LOGO_SRC = '/partners/bridge-bio.svg';

export const CASRCADE_LOGO_SRC = '/partners/casrcade.svg';

// LIMS-side `campaigns_campaign.code` for the BridgeBio FVT program.
export const BRIDGE_BIO_CAMPAIGN_CODE = 'BRIDGEBIO';

export const BRIDGE_BIO_PARTNERSHIP_PATH = '/partnership/bridgebio';

export const BRIDGE_BIO_MATERIAL_CODE = 'MED-US-ECLTX-0031';

export const shouldHideUtilityResources = (
  pathname: string,
  campaignCode: string,
  isLoggedInProfilePending = false,
): boolean =>
  isLoggedInProfilePending ||
  campaignCode === BRIDGE_BIO_CAMPAIGN_CODE ||
  pathname.startsWith('/fvt') ||
  pathname.startsWith(BRIDGE_BIO_PARTNERSHIP_PATH) ||
  pathname.startsWith('/partnerships/bridgebio');
